/** Norsk (bokmål) — the platform default and the source of truth for all keys. */
export default {
  header: {
    features: 'Funksjoner',
    pricing: 'Priser',
    contact: 'Kontakt',
    getStarted: 'Kom i gang',
    login: 'Logg inn',
  },

  footer: {
    description:
      'En plattform for medlemmer, utleie av lokaler, arrangementer og regnskap, laget for foreninger.',
    product: 'Produkt',
    help: 'Hjelp',
    legal: 'Juridisk',
    features: 'Funksjoner',
    pricing: 'Priser',
    getStarted: 'Kom i gang',
    contactUs: 'Kontakt oss',
    privacy: 'Personvern',
    terms: 'Vilkår',
    copyright: 'Alle rettigheter reservert.',
  },

  home: {
    unknownTenant:
      'Fant ingen aktiv forening på {host}. Hvis foreningen nettopp ble opprettet kan det ta noen minutter før siden er klar - prøv å laste siden på nytt om litt. Er du usikker på adressen, eller problemet vedvarer, ta gjerne',
    unknownTenantHere: 'denne adressen',
    unknownTenantContact: 'kontakt med oss',
    heroTitlePre: 'Digitiser din forening med',
    heroSubtitle:
      'En plattform for medlemmer, utleie av lokaler, arrangementer og regnskap, laget for foreninger.',
    ctaFree: 'Kom i gang gratis',
    learnMore: 'Lær mer',
    featuresTitle: 'Det du trenger for å drive foreningen',
    featuresSubtitle: 'Verktøyene samlet i én plattform',
    features: [
      { icon: '👥', title: 'Medlemsregister', desc: 'Medlemmer, medlemskap og husstander, med faktura når medlemskapet fornyes.' },
      { icon: '🏠', title: 'Utleie av lokaler', desc: 'Booking med priser, kontrakt, depositum og faktura.' },
      { icon: '📅', title: 'Arrangementer', desc: 'Billettsalg med kapasitet, og QR-kode ved døren.' },
      { icon: '💳', title: 'Faktura og betaling', desc: 'Fakturaer og kreditnotaer, og betaling med kort og Vipps via Nets.' },
      { icon: '📧', title: 'E-post og SMS', desc: 'Bekreftelser, påminnelser, fakturaer og billetter sendes automatisk.' },
      { icon: '🌐', title: 'Egen nettside', desc: 'Foreningens egen side med sider, nyheter og eget utseende.' },
    ],
    stepsTitle: 'Slik kommer du i gang',
    steps: [
      { num: 1, title: 'Send forespørsel', desc: 'Fortell oss om foreningen, så setter vi opp siden deres.' },
      { num: 2, title: 'Sett opp', desc: 'Legg inn lokaler, medlemskapstyper og priser.' },
      { num: 3, title: 'Ta det i bruk', desc: 'Ta imot bookinger, selg billetter og send fakturaer.' },
    ],
    ctaTitle: 'Klar for å forenkle foreningslivet?',
    ctaText: 'Start gratis i dag. Ingen bindingstid.',
    ctaButton: 'Kom i gang gratis',
    heroImageAlt: 'Oversikten i administrasjonen til en demoforening',
  },

  features: {
    heroTitle: 'Kraftige funksjoner for din forening',
    heroSubtitle: 'Medlemmer, utleie, arrangementer, faktura og regnskap i én plattform.',
    list: [
      {
        icon: '👥',
        title: 'Medlemsadministrasjon',
        description: 'Medlemmer, medlemskap og husstander samlet på ett sted.',
        details: [
          'Medlemskapstyper og husstand med barn',
          'Fornyelse med faktura',
          'Dugnad og frivillige timer',
        ],
      },
      {
        icon: '🏠',
        title: 'Utleie av lokaler',
        description: 'Ta imot og følg opp bookinger.',
        details: [
          'Priser, tillegg og helligdager',
          'Kontrakt som signeres på nett',
          'Depositum og faktura',
        ],
      },
      {
        icon: '📅',
        title: 'Arrangementer',
        description: 'Selg billetter og slipp inn riktige personer.',
        details: [
          'Billettsalg med kapasitet',
          'Billettyper i rekkefølge, for eksempel early bird og dørsalg',
          'QR-kode ved døren',
        ],
      },
      {
        icon: '💳',
        title: 'Faktura og betaling',
        description: 'Fakturaer og kreditnotaer, og kortbetaling.',
        details: ['Faktura med purring', 'Kort og Vipps via Nets', 'Regnskap og kontoplan'],
      },
      {
        icon: '📧',
        title: 'Kommunikasjon',
        description: 'Meldinger sendes automatisk til rett tid.',
        details: ['E-post og SMS', 'Maler på flere språk', 'Varsler til rett tid'],
      },
      {
        icon: '🌐',
        title: 'Egen nettside',
        description: 'Foreningens egen side med sider og nyheter.',
        details: ['Sider og nyheter', 'Tre utseender og egne farger', 'Eget domene (settes opp av oss)'],
      },
      {
        icon: '🔐',
        title: 'Sikkerhet og personvern',
        description: 'Hver forening er skilt fra de andre.',
        details: [
          'Tofaktor-pålogging',
          'Data lagres i Norge',
          'Innsyn, eksport og sletting av personopplysninger',
        ],
      },
    ],
    ctaTitle: 'Klar for å komme i gang?',
    ctaText: 'Start gratis i dag og opplev hvor enkelt det kan være å drive en forening.',
    ctaButton: 'Kom i gang gratis',
    screensTitle: 'Slik ser det ut',
    screensSubtitle:
      'Skjermbilder fra en demoforening med oppdiktede data. Administrasjonen er på norsk.',
    screens: [
      { title: 'Oversikt', text: 'Det som trenger oppfølging, og hva som skjer fremover, på én side.' },
      { title: 'Bookinger', text: 'Forespørsler, bekreftelser og status på alle bookinger.' },
      { title: 'Kalender', text: 'Besøkende ser når lokalene er ledige og hva som skjer i huset.' },
      { title: 'Billetter', text: 'Salg per billettype, deltakere og innsjekk.' },
      { title: 'Velg plass', text: 'Kjøperen velger plassene sine på kartet av lokalet.' },
      { title: 'Salkart', text: 'Dra bord, stoler, scene og bar inn på kartet, med plantegningen som bakgrunn.' },
      { title: 'Medlemskap', text: 'Medlemmer, medlemskapstyper og husstander.' },
      { title: 'Fakturaer', text: 'Fakturaer og kreditnotaer med status, forfall og utestående.' },
      { title: 'På telefonen', text: 'Foreningens nettside fungerer på telefon.' },
    ],
  },

  pricing: {
    heroTitle: 'Enkel og transparent prising',
    heroSubtitle: 'Velg planen som passer din forening.',
    loading: 'Laster priser...',
    loadError: 'Kunne ikke hente oppdaterte priser. Viser lagrede priser.',
    popular: 'Mest populær',
    perMonth: 'kr/mnd',
    unlimited: 'Ubegrenset',
    unlimitedMembers: 'Ubegrensede medlemmer',
    upToMembers: 'Opptil {count} medlemmer',
    prioritySupport: 'Prioritert support: påbegynt innen 30 minutter, hverdager 09–15',
    planDescFree: 'For små foreninger',
    planDescStandard: 'For aktive foreninger',
    planDescAdvanced: 'For store organisasjoner',
    ctaFree: 'Kom i gang gratis',
    ctaTrial: 'Send forespørsel',
    faqTitle: 'Ofte stilte spørsmål',
    faq: [
      { q: 'Kan jeg bytte plan når som helst?', a: 'Ja, ta kontakt, så bytter vi planen.' },
      { q: 'Hva skjer hvis vi overstiger medlemsgrensen?', a: 'Vi tar kontakt og avtaler en oppgradering. Ingenting stenges uten at vi har snakket med dere.' },
      { q: 'Er det bindingstid?', a: 'Nei, alle planer kan sies opp når som helst.' },
      { q: 'Tilbyr dere rabatter for ideelle organisasjoner?', a: 'Ja, kontakt oss for spesielle priser for ideelle organisasjoner.' },
      { q: 'Hva koster kortbetaling?', a: 'Kort og Vipps går via Nets. Foreningen har en egen avtale med Nets og betaler gebyret direkte til dem.' },
    ],
    emailSms: 'E-post og SMS',
    bookingsPerMonth: '{count} bookinger i måneden',
    unlimitedBookings: 'Ubegrensede bookinger',
    ticketsPerMonth: '{count} billetter i måneden',
    unlimitedTickets: 'Ubegrensede billetter',
    locations: 'Opptil {count} lokaler',
    unlimitedLocations: 'Ubegrensede lokaler',
    storage: '{size} lagring',
    customBranding: 'Eget utseende og egne farger',
    exportCsv: 'Eksport til CSV',
    introNotice:
      'I en innledende periode er alle planer gratis. Vi varsler minst 30 dager før fakturering starter.',
  },

  contact: {
    heroTitle: 'Kontakt oss',
    heroSubtitle: 'Vi er her for å hjelpe. Skriv til oss, så svarer vi så fort vi kan.',
    formTitle: 'Skriv til oss',
    formIntro:
      'Har du spørsmål om CommunityNord, priser, eller hvordan vi kan hjelpe din forening? Fyll ut skjemaet, eller send oss en e-post.',
    email: 'E-post',
    name: 'Navn',
    organization: 'Forening/Organisasjon',
    subject: 'Emne',
    chooseSubject: 'Velg emne',
    subjectGeneral: 'Generelt spørsmål',
    subjectPricing: 'Priser og abonnement',
    subjectSupport: 'Teknisk support',
    subjectDemo: 'Be om demo',
    subjectPartnership: 'Samarbeid',
    message: 'Melding',
    send: 'Send melding',
    success: 'Takk! Vi har mottatt henvendelsen din og tar kontakt så snart vi kan.',
    error: 'Noe gikk galt. Prøv igjen, eller send oss en e-post.',
    tooMany: 'Du har sendt mange henvendelser. Prøv igjen senere, eller send oss en e-post.',
    sending: 'Sender...',
    supportNote:
      'Standard og Avansert har prioritert support: vi begynner på saken innen 30 minutter, hverdager 09–15.',
  },

  login: {
    title: 'Logg inn',
    subtitle:
      'Hver forening har sin egen innlogging. Skriv foreningens adresse, så tar vi deg dit.',
    label: 'Foreningens adresse',
    placeholder: 'foreningen',
    button: 'Gå til innlogging',
    hint:
      'Har foreningen eget domene, bruker du det i stedet. Finner du ikke adressen, spør styret eller ta kontakt med oss.',
    invalid: 'Bruk bare små bokstaver, tall og bindestrek.',
  },

  signup: {
    heroTitle: 'Kom i gang med CommunityNord',
    heroSubtitle:
      'Fyll ut skjemaet for å opprette en ny forening. Vi sender deg en e-post når kontoen din er klar.',
    formTitle: 'Opprett ny forening',
    success:
      'Takk for din henvendelse! Vi har mottatt din forespørsel og vil kontakte deg så snart kontoen din er klar.',
    error: 'Det oppstod en feil ved innsending. Vennligst prøv igjen eller kontakt oss.',
    orgName: 'Organisasjonsnavn',
    orgNamePlaceholder: 'Foreningens navn',
    contactPerson: 'Kontaktperson',
    contactPersonPlaceholder: 'Ditt fulle navn',
    email: 'E-post',
    phone: 'Telefon',
    plan: 'Ønsket abonnement',
    messageOptional: 'Melding (valgfritt)',
    messagePlaceholder: 'Fortell oss litt om foreningen din...',
    sending: 'Sender...',
    submit: 'Send forespørsel',
    free: 'Gratis',
    perMonth: 'kr/mnd',
    upTo50: 'Opptil 50 medlemmer',
    upTo500: 'Opptil 500 medlemmer',
    unlimitedMembers: 'Ubegrensede medlemmer',
    nextTitle: 'Hva skjer videre?',
    nextSteps: [
      { title: 'Søknad sendt', desc: 'Vi mottar din søknad og sender bekreftelse til din e-post.' },
      { title: 'Behandling', desc: 'Vårt team behandler søknaden din vanligvis innen 1-2 virkedager.' },
      { title: 'Velkomst', desc: 'Du får en invitasjonslenke på e-post for å opprette kontoen din.' },
    ],
    questionsTitle: 'Har du spørsmål?',
    questionsContact: 'Kontakt oss på',
  },

  onboarding: {
    homeTitle: 'CommunityNord Onboarding',
    homeSubtitle:
      'For å opprette en ny organisasjon trenger du en invitasjonslenke. Kontakt en administrator for å få tilsendt en.',
    homeGotLink: 'Har du mottatt en lenke?',
    homeGotLinkText:
      'Klikk på lenken du har fått tilsendt via e-post for å starte oppsettet av din organisasjon.',
    homeBack: '← Tilbake til communitynord.com',
    validating: 'Validerer invitasjonen...',
    invalidTitle: 'Invitasjon ugyldig',
    invalidContact: 'Kontakt administratoren for å få en ny invitasjonslenke.',
    connectError: 'Kunne ikke koble til serveren. Prøv igjen senere.',
    deviceBound:
      'Denne lenken er allerede åpnet på en annen enhet, og er knyttet til den. Åpne lenken på den første enheten for å fortsette, eller skriv til support@communitynord.com, så sender vi en ny lenke.',
    genericError: 'Noe gikk galt. Prøv igjen.',
    steps: ['Velkommen', 'Organisasjon', 'Kontakt', 'Brukerkonto', 'Bekreft'],
    step1Title: 'Velkommen til CommunityNord',
    step1Subtitle:
      'Du er invitert til å opprette en ny organisasjon. Vi guider deg gjennom oppsettet steg for steg.',
    step1Suggested: 'Foreslått navn:',
    step1SentTo: 'Invitasjon sendt til:',
    step1Expires: 'Invitasjonen utløper:',
    step1Needs: 'Dette trenger du:',
    step1NeedsList: [
      'Navn på organisasjonen',
      'Kontaktinformasjon',
      'Eventuelt organisasjonsnummer',
      'Ønsket brukernavn og passord',
    ],
    step1Start: 'Kom i gang →',
    back: '← Tilbake',
    next: 'Neste →',
    step2Title: 'Om organisasjonen',
    step2Subtitle: 'Fortell oss om organisasjonen som skal bruke plattformen.',
    orgName: 'Organisasjonsnavn',
    orgNamePlaceholder: 'F.eks. Bergen Ungdomshus',
    orgNameRequired: 'Organisasjonsnavn er påkrevd',
    slug: 'URL-prefix (slug)',
    slugRequired: 'URL-prefix er påkrevd',
    slugFormat: 'Kun små bokstaver, tall og bindestrek',
    slugMin: 'Minst 2 tegn',
    shortName: 'Kortnavn',
    shortNameRequired: 'Kortnavn er påkrevd',
    shortNameMax: 'Maks 10 tegn',
    shortNameFormat: 'Kun bokstaver og tall',
    shortNameHint: 'Brukes som prefiks i fakturanr. o.l.',
    customDomain: 'Eget domene',
    customDomainPlaceholder: 'f.eks. eksempel.no',
    customDomainHint: 'Valgfritt. Brukes for tilgang via eget domene i tillegg til subdomene.',
    customDomainNoProtocol: 'Skriv kun domenet, uten http:// eller https://',
    customDomainNoPath: 'Skriv kun domenet, uten sti',
    customDomainInvalid: 'Ugyldig domeneformat',
    country: 'Land',
    countryHint: 'Landet organisasjonen hører hjemme i',
    countryNames: { NO: 'Norge', SE: 'Sverige', DK: 'Danmark' },
    orgNumber: 'Organisasjonsnummer',
    orgNumberHint: 'Valgfritt. Organisasjonsnummer.',
    appearance: 'Utseende',
    layout: 'Utseende på nettsiden',
    layoutHint: 'Kan endres når som helst under Admin → Merkevare.',
    layouts: [
      { key: 'classic', name: 'Klassisk', description: 'Tradisjonelt oppsett med sentrert innhold og logo til venstre. Passer de fleste.' },
      { key: 'modern', name: 'Moderne', description: 'Fullbredde forside og kompakt meny. Frisk og luftig stil.' },
      { key: 'compact', name: 'Kompakt', description: 'Minimal luft og tett informasjon. Bra for innholdsrike sider.' },
      { key: 'custom', name: 'Skreddersydd', description: 'Eget design satt opp i samarbeid med oss. Vi tar kontakt.' },
    ],
    tagline: 'Slagord / motto',
    taglinePlaceholder: 'F.eks. «Sammen skaper vi aktivitet»',
    taglineHint: 'Valgfritt. Vises i bunnteksten på nettsiden.',
    logo: 'Logo',
    logoUpload: 'Last opp logo',
    logoChange: 'Bytt bilde',
    logoRemove: 'Fjern',
    logoHint: 'Valgfritt. PNG/JPG/SVG, maks 2 MB. Kan også legges til senere.',
    logoTooBig: 'Bildet er for stort (maks 2 MB)',
    logoNotImage: 'Filen må være et bilde',
    logoUseUrl: 'Bruk URL i stedet',
    logoUrlPlaceholder: 'https://...',
    logoUrlHint: 'Absolutt URL til logoen (https://...).',
    subscriptionPlan: 'Abonnementsplan',
    subscriptionPlanHint: 'Denne planen settes som startplan for tenant og kan endres i portal senere.',
    step3Title: 'Kontaktinformasjon',
    step3Subtitle: 'Hvem er hovedkontakt for organisasjonen? Denne personen blir eier av kontoen.',
    contactPerson: 'Kontaktperson',
    contactPersonRequired: 'Kontaktperson er påkrevd',
    email: 'E-postadresse',
    emailRequired: 'E-post er påkrevd',
    emailInvalid: 'Ugyldig e-postadresse',
    phone: 'Telefonnummer',
    postalAddress: 'Postadresse',
    optional: '(valgfritt)',
    streetAddress: 'Gateadresse',
    city: 'Sted',
    postalCode: 'Postnr.',
    sameAsPostal: 'Besøksadresse er samme som postadresse',
    visitingAddress: 'Besøksadresse',
    step4Title: 'Opprett brukerkonto',
    step4Subtitle:
      'Denne brukeren blir eier av organisasjonen og har full tilgang. Du kan legge til flere brukere senere.',
    username: 'Brukernavn',
    usernameRequired: 'Brukernavn er påkrevd',
    usernameMin: 'Minst 3 tegn',
    usernameMax: 'Maks 256 tegn',
    usernameEmailInvalid: 'Ugyldig e-postformat',
    usernameFormat:
      'Bruk brukernavn-format (a-z, 0-9, punktum, understrek, bindestrek) eller en gyldig e-postadresse',
    usernamePlaceholder: 'ola.nordmann eller navn@domene.no',
    usernameHint: 'Brukes til innlogging. Kan være brukernavn eller e-postadresse.',
    loginEmail: 'E-post (til innlogging)',
    loginEmailHint: 'Satt fra kontaktinformasjonen i forrige steg.',
    password: 'Passord',
    passwordRequired: 'Passord er påkrevd',
    passwordMin: 'Minst 8 tegn',
    passwordShow: 'Vis',
    passwordHide: 'Skjul',
    passwordHint: 'Tips: Bruk en kombinasjon av store/små bokstaver, tall og spesialtegn.',
    passwordConfirm: 'Bekreft passord',
    passwordConfirmPlaceholder: 'Gjenta passordet',
    passwordMismatch: 'Passordene er ikke like',
    step5Title: 'Bekreft og opprett',
    step5Subtitle:
      'Se over informasjonen før du oppretter organisasjonen. Du kan gå tilbake for å gjøre endringer.',
    reviewOrg: 'Organisasjon',
    reviewName: 'Navn',
    reviewUrl: 'URL',
    reviewCustomDomain: 'Eget domene',
    reviewCountry: 'Land',
    reviewShortName: 'Kortnavn',
    reviewOrgNumber: 'Org.nr',
    reviewPlan: 'Abonnement',
    reviewLayout: 'Utseende',
    reviewTagline: 'Slagord',
    reviewLogo: 'Logo',
    reviewContact: 'Kontakt',
    reviewContactPerson: 'Kontaktperson',
    reviewEmail: 'E-post',
    reviewPhone: 'Telefon',
    reviewPostal: 'Postadresse',
    reviewVisiting: 'Besøksadresse',
    reviewAddress: 'Adresse',
    reviewPlace: 'Sted',
    reviewAccount: 'Brukerkonto',
    reviewUsername: 'Brukernavn',
    reviewPassword: 'Passord',
    reviewRole: 'Rolle',
    reviewOwner: 'Eier (Owner)',
    creating: 'Oppretter...',
    create: 'Opprett organisasjon ✓',
    successTitle: '{name} er opprettet!',
    successAwaiting:
      'Vi klargjør nå nettsiden deres — dette er et manuelt steg hvor vi kontrollerer at alt er riktig satt opp. Dere får en e-post til {email} så snart siden er klar til bruk.',
    successAwaitingNoEmail:
      'Vi klargjør nå nettsiden deres — dette er et manuelt steg hvor vi kontrollerer at alt er riktig satt opp. Dere får en e-post så snart siden er klar til bruk.',
    successWhatNow: 'Hva skjer nå?',
    successStep1: 'Vi kontrollerer oppsettet og gjør siden klar. Dette tar vanligvis kort tid.',
    successStep2: 'Dere får en e-post når siden er klar, med lenke til innlogging.',
    successStep3: 'Logg inn med brukernavnet {username} og passordet dere valgte.',
    successDetails: 'Dine detaljer',
    successOrg: 'Organisasjon',
    successUrl: 'Nettadresse',
    successUsername: 'Brukernavn',
    successDnsTitle: 'Eget domene: {domain}',
    successDnsIntro:
      'For at {domain} skal peke til nettsiden deres, må DNS-innstillingene hos domeneleverandøren deres oppdateres. Velg ett av alternativene:',
    successDnsCnameTitle: 'Alternativ 1 — CNAME (enklest)',
    successDnsCnameText: 'Opprett en CNAME-post som peker til subdomenet deres:',
    successDnsATitle: 'Alternativ 2 — A-post',
    successDnsAText: 'Pek domenet direkte til vår server-IP:',
    successDnsNote:
      'DNS-endringer kan ta opptil noen timer å tre i kraft. Merk: en CNAME kan ikke brukes på et rot-domene (eksempel.no) hos alle leverandører — bruk da A-post, eller CNAME på www. Vi verifiserer domenet som en del av klargjøringen.',
    successDnsType: 'Type',
    successDnsName: 'Navn/vert',
    successDnsValue: 'Verdi/mål',
  },
}
